module.exports = {
  FINALIZED: 'finalized',
  OPENED: 'opened',
  UNOPENED: 'unopened',
};
